import { GET_ALL_INVOICES, GET_ALL_INVOICES_ERROR, GET_DUE_AMOUNTS, GET_DUE_AMOUNTS_ERROR,
    SET_INVOICE_PAYMENT_MEDIUM, SET_INVOICE_PAYMENT_MEDIUM_ERROR,
    UPDATE_STATUS_FORFINANCE,UPDATE_STATUS_FORFINANCE_ERROR,
    INSERT_BUDGET_AMOUNT,INSERT_BUDGET_AMOUNT_ERROR,GET_ALL_INVOICES_FOR_SPECIAL_CASE,
    GET_BUDGET_AMOUNT, GET_BUDGET_AMOUNT_ERROR,GET_ALL_INVOICES_FOR_SPECIAL_CASE_ERROR,
    UPDATE_PRIORITY, UPDATE_PRIORITY_ERROR,
    GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED,
    GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED_ERROR,
    UPDATE_PAYABLE_AMOUNT_IN_INVOICE, UPDATE_PAYABLE_AMOUNT_IN_INVOICE_ERROR,
    UPDATE_COMMENT_IN_INVOICE,UPDATE_COMMENT_IN_INVOICE_ERROR,
    POST_SPLIT_BUDGET, POST_SPLIT_BUDGET_ERROR,
    GET_SPLIT_BUDGET, GET_SPLIT_BUDGET_ERROR,
    GET_ALL_INVOICES_FOR_SUPLLIER, GET_ALL_INVOICES_FOR_SUPLLIER_ERROR,
     POST_INVOICE_DETAILS, POST_INVOICE_DETAILS_ERROR ,
     GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL, GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL_ERROR ,
    } from '../type'
// import axios from 'axios';
import env from '../../ENV';
import axios from 'axios';
import AxiosHandler from '../../Classes/AxiosHandler';
let ROOT_URL = env.BACKEND_URL;

export const getAllInvoices = (data) => async dispatch => {
    try{
        const res = await AxiosHandler.post(`${ROOT_URL}invoice/${data.role}/${data.group}`, data);
        dispatch( {
            type: GET_ALL_INVOICES,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_ALL_INVOICES_ERROR,
            payload: console.log(e),
        })
    }
}

export const getDueAmounts = () => async dispatch => {
    try{
        const res = await AxiosHandler.get(`${ROOT_URL}invoice/dues`);
        dispatch( {
            type: GET_DUE_AMOUNTS,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_DUE_AMOUNTS_ERROR,
            payload: console.log(e),
        })
    }
}

export const setInvoicePaymentMedium = (input) => async dispatch => {
    
    console.log("recieved in store ", input)
    try{
        const res = await axios({
            method: 'patch',
            url: `${ROOT_URL}invoice/payment-medium`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: SET_INVOICE_PAYMENT_MEDIUM,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: SET_INVOICE_PAYMENT_MEDIUM_ERROR,
            payload: console.log(e),
        })
    }

}

export const updateStatusForFinance = (InvoiceStatusId,invoiceid) => async dispatch => {
    
    // console.log("recieved in store ", input)
    try{
        const res = await axios({
            method: 'patch',
            url: `${ROOT_URL}invoice/${InvoiceStatusId}/${invoiceid}`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: UPDATE_STATUS_FORFINANCE,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: UPDATE_STATUS_FORFINANCE_ERROR,
            payload: console.log(e),
        })
    }

}
//INSERT_BUDGET_AMOUNT

export const insertbudgetamount = (data) => async dispatch => {

    console.log(data)
    
    try{
        const res = await axios({
            method: 'post',
            data:data,
            url: `${ROOT_URL}budgetamount`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: INSERT_BUDGET_AMOUNT,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: INSERT_BUDGET_AMOUNT_ERROR,
            payload: console.log(e),
        })
    }

}

export const getBudgetAmount = (input) => async dispatch => {
    
    console.log("recieved in store ", input)
    try{
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}invoice/budgetamount`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: GET_BUDGET_AMOUNT,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_BUDGET_AMOUNT_ERROR,
            payload: console.log(e),
        })
    }
}

export const updatePriority = (invoiceid,priority,userId,userName) => async dispatch => {
    
    try{
        const res = await axios({
            method: 'patch',
            url: `${ROOT_URL}${invoiceid}/${priority}/${userId}/priority-invoice`,
            data: {userName:userName},
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: UPDATE_PRIORITY,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: UPDATE_PRIORITY_ERROR,
            payload: console.log(e),
        })
    }
}

export const getAllInvoicesForSpecialCase = (roleid,groupid, params) => async dispatch => {
    try{
        const res = await AxiosHandler.post(`${ROOT_URL}invoices-for-special/${roleid}/${groupid}`, params);
        dispatch( {
            type: GET_ALL_INVOICES_FOR_SPECIAL_CASE,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_ALL_INVOICES_FOR_SPECIAL_CASE_ERROR,
            payload: console.log(e),
        })
    }
}

export const getAllInvoicesWherePaymentRecieved = (roleid,groupid) => async dispatch => {
    try{
        const res = await AxiosHandler.get(`${ROOT_URL}invoices/payement-received/${roleid}/${groupid}`);
        dispatch( {
            type: GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED_ERROR,
            payload: console.log(e),
        })
    }
}


export const updateCommentInInvoice = (Comments,InvoiceId) => async dispatch => {
    console.log("recieved in store ", Comments,InvoiceId)
    try{
        const res = await axios({
            method: 'patch',
            url: `${ROOT_URL}invoice-comment/${Comments}/${InvoiceId}`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: UPDATE_COMMENT_IN_INVOICE,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: UPDATE_COMMENT_IN_INVOICE_ERROR,
            payload: console.log(e),
        })
    }
}


export const updatePayableAmountInInvoice = (PayableAmount,InvoiceId,groupId) => async dispatch => {
    console.log("recieved in store ", PayableAmount, InvoiceId)
    try{
        const res = await axios({
            method: 'patch',
            url: `${ROOT_URL}invoice-payableamount/${PayableAmount}/${InvoiceId}/${groupId}`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: UPDATE_PAYABLE_AMOUNT_IN_INVOICE,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: UPDATE_PAYABLE_AMOUNT_IN_INVOICE_ERROR,
            payload: console.log(e),
        })
    }
}

export const postSplitBudget = (data) => async dispatch => {
    
    var params = {
        BudgetAmountId: data.BudgetAmountId,
        AmountForKhurda: data.AmountForKhurda,
        AmountForOthers: data.AmountForOthers,
        SplitBudgetRecordsId: data.SplitBudgetRecordsId,
    }

    console.log("recieved in store ", data)
    try{
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}insert-split-budget/${params.BudgetAmountId}/${params.AmountForKhurda}/${params.AmountForOthers}/${params.SplitBudgetRecordsId}`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: POST_SPLIT_BUDGET,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: POST_SPLIT_BUDGET_ERROR,
            payload: console.log(e),
        })
    }

}

export const getSplitBudget = (data) => async dispatch => {

    var params = {
        StartDate: data.StartDate,
        EndDate: data.EndDate,
    }
    
    try{
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}get-split-budget/${params.StartDate}/${params.EndDate}`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: GET_SPLIT_BUDGET,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_SPLIT_BUDGET_ERROR,
            payload: console.log(e),
        })
    }

}
export const GetAllInvoicesForSupplier = (input,) => async dispatch => {
    console.log(input,"Action-Store")
    try{

        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}getAllInvoicesForSupplier`,
            data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: GET_ALL_INVOICES_FOR_SUPLLIER,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_ALL_INVOICES_FOR_SUPLLIER_ERROR,
            payload: console.log(e),
        })
    }

}

export const InsertInvoiceDetails = (params) => async dispatch => {
    try{
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/post-invoice-details`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: POST_INVOICE_DETAILS,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: POST_INVOICE_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetInvoiceDetailsForAPteamApproval = (InvoiceDocId) => async dispatch => {
    try{
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}${InvoiceDocId}/get-invoice-details-for-Ap-team-approval`,
            data: '',
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch( {
            type: GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL_ERROR,
            payload: console.log(e),
        })
    }
}